import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "currentColor",
            d: "M10 2.083c2.276 0 4.126 2.045 4.166 4.583h1.667c.46 0 .834.374.834.834v10c0 .46-.373.833-.834.833H4.167c-.46 0-.834-.373-.834-.833v-10c0-.46.373-.833.834-.833h1.667l.004-.143C5.943 4.05 7.766 2.084 10 2.084zm5.417 5.834H4.583v9.166h10.834V7.917zM10 9.583c1.15 0 2.083.933 2.083 2.084 0 .932-.613 1.722-1.458 1.988V15c0 .345-.28.625-.625.625-.316 0-.578-.235-.62-.54L9.376 15v-1.345c-.845-.266-1.458-1.056-1.458-1.988 0-1.15.932-2.084 2.083-2.084zm0 1.25c-.46 0-.833.373-.833.834 0 .46.373.833.833.833.46 0 .833-.373.833-.833 0-.46-.373-.834-.833-.834zm0-7.5c-1.528 0-2.833 1.408-2.913 3.238l-.002.095h5.83l-.002-.095c-.078-1.77-1.302-3.146-2.766-3.233L10 3.333z",
            transform: "translate(-256 -1180) translate(256 1180)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }